import { render } from "./Salary_Reviews.vue?vue&type=template&id=a880e272"
import script from "./Salary_Reviews.vue?vue&type=script&lang=js"
export * from "./Salary_Reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__